import React from 'react';
import { Modal } from 'react-bootstrap';

const PopupModel = ({
    size='lg',
    showModal=false,
    handleCloseModal=()=>{},
    headerStyle={padding: '0.5rem', paddingBlock:'1rem' },
    title='',
    footerContent=null,
    children,
    type=null,
    couldCancel=true
}) => { 
  return (
      <Modal show={showModal} onHide={handleCloseModal} size={size} centered>
        <Modal.Header 
         closeButton={couldCancel}
        style={headerStyle}>
          <Modal.Title className='fs-5 fw-bold' style={{paddingLeft:'.85rem'}}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body >{children}</Modal.Body>
        {footerContent ?<Modal.Footer>{footerContent}</Modal.Footer>:null}
        
      </Modal>
  );
};

export default PopupModel;